import CoreLeagueSetupView from './CoreLeagueSetup';
import CoreHeaderView from './Header';
import CoreActivateGameView from './ActivateGame';
import CoreFooterView from './Footer';
import LoginOldView from './LoginOld';
import ContactUsCoreView from './ContactUs';
// import OnboardingView from './Onboarding';
import CoreHomeView from './Home';
import CoreLoginView from './Login';

import CoreMenuView from './Menu';

import Error404View from './Error404';

import {
	CorePasswordChangeView,
	CorePasswordChangeConfirmationView,
} from './Password';

import {
	CoreLeagueCreateView,
	CoreLeagueSettingsView,
	CoreLeagueJoinView,
	CoreLeagueCongratulationView,
	CoreLeagueInvitesView,
	CoreLeagueJoinBarView,
	CoreMyLeagueTableView,
	CoreRegenerationBarView,
	CoreJoinFilterView,
	CoreRegenerateLeagueTableView,
	CoreRegenerationRestartView,
	CoreRegenerationInviteView
} from './League';

import {
	CoreAccountSettingsView,
	CoreCommunicationsView
} from './Account';

export * from './widgets';
export * from './Rankings';
export * from './League/Ladder';
export * from './CelebrityPopup';
export * from './CorePrizes';
export * from './StatsItem';
export * from './GlobalNotification';

export {
	CoreLeagueSetupView,
	CoreHeaderView,
	CoreFooterView,
	CoreActivateGameView
};

export {
	CorePasswordChangeView,
	CorePasswordChangeConfirmationView
};

export {
	CoreRegenerateLeagueTableView,
	CoreRegenerationRestartView,
	CoreRegenerationInviteView,
	CoreRegenerationBarView,
	CoreLeagueCreateView,
	CoreLeagueSettingsView,
	CoreLeagueJoinView,
	CoreLeagueCongratulationView,
	CoreLeagueInvitesView,
	CoreJoinFilterView,
	CoreLeagueJoinBarView,
	CoreMyLeagueTableView
};

export {
	CoreAccountSettingsView,
	CoreCommunicationsView
};

export { CoreMenuView };

export { LoginOldView };

export { ContactUsCoreView };

// export { OnboardingView };

export { CoreHomeView };

export { CoreLoginView };

export { Error404View };

export default {
	CoreFooterView,
	CoreLeagueSetupView,
	CoreHeaderView,
	CoreActivateGameView,
	CoreLeagueCreateView,
	CoreLeagueSettingsView,
	CoreLeagueJoinView,
	CoreLeagueCongratulationView,
	CoreLeagueInvitesView,
	CoreJoinFilterView,
	CoreLeagueJoinBarView,
	CoreMyLeagueTableView,
	CoreMenuView,
	LoginOldView,
	CoreAccountSettingsView,
	CoreCommunicationsView,
	ContactUsCoreView,
	// OnboardingView,
	CoreHomeView,
	CoreLoginView,
	Error404View,
	CorePasswordChangeView,
	CorePasswordChangeConfirmationView
}